import { render, staticRenderFns } from "./Tsjydetail.vue?vue&type=template&id=59985a86&"
import script from "./Tsjydetail.vue?vue&type=script&lang=js&"
export * from "./Tsjydetail.vue?vue&type=script&lang=js&"
import style0 from "./Tsjydetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports